import axios, { getData } from 'lib/axios'
import openApiAxios from 'lib/openApiAxios'

export const dropdownYearlyReport = async () => {
  return axios.get(`admin/payroll/annual_report/years`).then(getData)
}

export const employeeListYearlyReport = async (year) => {

  const query = year ? `?year=${year}` : ''
  return axios.get(`admin/payroll/annual_report/staff${query}`).then(getData)
}

export const emailAnnualReport = async (data) => {
  return axios.post('admin/payroll/annual_report/notify', data).then(getData)
}

export const downloadAnnualReport = async (data) => {
  const res = await axios.post('admin/payroll/annual_report/download', data, {
    responseType: 'blob',
  })
  return res
}

export const downloadEDataPraisi = async (year) => {
  const res = await axios.get(`admin/payroll/annual_report/export?year=${year}`, {
    responseType: 'blob',
  })
  return res
}

export const downloadIndividualAnnualReport = async (data) => {
  const res = await axios.post('payroll/annual_report/download', data, {
    responseType: 'blob',
  })
  return res
}

export const downloadEAFormSheet = async () => {
  return await openApiAxios.get('/ea-form/download', { responseType: 'blob' })
}

export const uploadEAFormSheet = async (data, signal) => {
  const response = await openApiAxios.post('/ea-form/upload', data, {
    signal,
  })
  return response.data
}

export const generateEAFormPDF = async (data) => {
  return await openApiAxios.post('/ea-form/generate', data, { responseType: 'blob' })
}
